import React from "react";
import { Link } from "react-router-dom";

function Companyexample() {
  // Car rental company data
  const company = {
    id: "car-rent-company",
    name: "Elite Car Rentals",
    description:
      "Drive in style with our premium selection of cars. From budget-friendly sedans to luxury VIP rides, we offer reliable rentals for every occasion.",
    profilePic:
      "https://images.unsplash.com/photo-1502877338535-766e1452684a?w=300&h=300&fit=crop&crop=faces", // company logo/banner
    products: [
      {
        id: "toyota-corolla",
        name: "Toyota Corolla",
        description: "Comfortable and fuel-efficient sedan, perfect for city rides.",
        price: 50,
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRSPSSJWD-hx0E-GYlBC0TpJXIRKS3hEPUBbA&s",
        type: "rental",
        companyId: "car-rent",
      },
      {
        id: "honda-civic",
        name: "Honda Civic",
        description: "Stylish and modern sedan, smooth driving experience.",
        price: 55,
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTIxM2qnZxLPuOnX3iesLJfevklK-0Ycmuc0A&s",
        type: "rental",
        companyId: "car-rent",
      },
      {
        id: "mercedes-s",
        name: "Mercedes S-Class",
        description:
          "Luxury VIP sedan offering unmatched comfort and performance.",
        price: 200,
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTz3Ou8Tbe678E6SjWKZ5Kh_UupRmzZPCutpw&s",
        type: "rental",
        companyId: "vip-rent",
      },
      {
        id: "bmw-7",
        name: "BMW 7 Series",
        description: "Executive luxury car with premium features and design.",
        price: 180,
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYWA0kvSrH5iLVZV1HlgDrjdkB1JrVqDI2IA&s",
        type: "rental",
        companyId: "vip-rent",
      },
    ],
  };

  return (
    <div className="container mx-auto py-10 px-4">
      {/* Profile Header */}
      <div className="bg-white shadow-lg rounded-2xl p-8 flex flex-col items-center text-center">
        <img
          src={company.profilePic}
          alt={company.name}
          className="w-32 h-32 rounded-full object-cover border-4 border-indigo-600 shadow-md"
        />
        <h1 className="mt-4 text-3xl font-extrabold text-gray-900">
          {company.name}
        </h1>
        <p className="mt-3 text-gray-600 max-w-2xl">{company.description}</p>
      </div>

      {/* Products List */}
      <h2 className="mt-12 text-2xl font-bold text-gray-800 text-center">
        Available Cars
      </h2>
      <div className="mt-8 grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {company.products.map((product) => (
          <Link
            key={product.id}
            to={`/product/${product.id}`}
            state={product}
            className="group bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl hover:scale-[1.03] transition transform"
          >
            <img
              src={product.image}
              alt={product.name}
              className="w-full h-48 object-cover group-hover:opacity-90 transition"
            />
            <div className="p-5">
              <h3 className="text-lg font-bold text-gray-900">
                {product.name}
              </h3>
              <p className="mt-1 text-sm text-gray-600 line-clamp-2">
                {product.description}
              </p>
              <p className="mt-3 text-indigo-600 font-semibold text-lg">
                ${product.price} / day
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Companyexample;